
import { withRouter } from 'react-router';
import AccountEditPaymentContainer from './AccountEditPaymentAuthContainer/index';

const AccountEditPayment = withRouter(AccountEditPaymentContainer);

export default AccountEditPayment;